export function splitAddress({address}) {
    const parts = address.split(', ');
    return parts[parts.length - 1].trim();   
}